// extracted by mini-css-extract-plugin
export var details = "_m1-0";
export var inspectorPopover = "_m1-1";